{% block ecocode_trustpilot_additional_settings %}
    <div class="ecocode-trustpilot-additional-settings">
        <sw-button
                @click="openConfirmModal"
                variant="critical"
                size="large"
        >
            {{ $tc('ecocode-trustpilot.config.additionalSettings.unlinkAccount.unlinkButton') }}
        </sw-button>
        <ecocode-trustpilot-info-text
                :text="$tc('ecocode-trustpilot.config.additionalSettings.unlinkAccount.unlinkButtonInfo')"
        />
        <sw-confirm-modal
                v-if="showConfirmModal"
                :title="$tc('ecocode-trustpilot.config.additionalSettings.unlinkAccount.confirmTitle')"
                :text="$tc('ecocode-trustpilot.config.additionalSettings.unlinkAccount.confirmText')"
                @confirm="onConfirm"
                @close="onClose"
                @cancel="onClose"
        />
    </div>
{% endblock %}
